import React, { useEffect, useState, useRef } from "react";
import { Avatar, Button, Iconography, IconographySizes, IconographyThemes, Loader, LoaderSizes, Modal, Link } from "@hid-galaxy-ui/galaxy-react";
import "./Calculator.scss";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux";
import { getPartnerEngagementCategoryListSagaAction } from "../../../../../../../redux/saga/partner-program/engagement-configuration/saga-actions";
import { AddCalculator, getFileUrl, getPartnerPoints, getPartnerPointsDraftSummary, getPartnerPointsSummary, SaveDraft } from "../../../../../../../redux/saga/partner-program/calculator/saga-action";
import { MenuItem, Select } from "@mui/material";
import { AvatarSizes } from "@hid-galaxy-ui/galaxy-react/components/Avatar/AvatarEnums";
import CommentModal from "./CommentModal";
import ActivityDescriptionModal from "../../../../../../../common/components/partner-program/ActivityDescriptionModal";
import ActivityDescriptionLink from "../../../../../../../common/components/partner-program/ActivityDescriptionLink";
import { partnerProgramEventConfigurationSliceAction } from "../../../../../../../redux/slices/partner-program/calculator";

const Calculator: React.FC<{ readOnly?: boolean }> = ({ readOnly = false }) => {
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState({
    // Summary
    currentTier: "Registered",
    totalPoints: 0,
    pointsToNextTier: 0,
    licencesToNextTier: 0,
    potentialPoints: 0,

    // Licenses
    netNewLicenses: 0,
    totalLicenses: 0,

    // Points Accelerators
    extraPoints: 0,
    regionalModifier: 1,
    totalMultiplier: 0,

    // Comments
    comment: "",
    tier_id: 0,

    // Files
    documents: [],
  });

  const [expanded, setExpanded] = useState('');
  const [oldExpandKey, setOldExpanded] = useState('');

  const [showCalendar, setShowCalendar] = useState(false);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [showAssessmentDatePicker, setShowAssessmentDatePicker] = useState(false);
  const [showAssessmentCalendar, setShowAssessmentCalendar] = useState(false);
  const assessmentDatePickerRef = useRef<HTMLDivElement>(null);
  const netNewLicensesInputRef = useRef<HTMLInputElement>(null);
  const totalLicensesInputRef = useRef<HTMLInputElement>(null);
  const [netNewLicensesDisplay, setNetNewLicensesDisplay] = useState<string | null>(null);
  const [assessmentCalendarMonth, setAssessmentCalendarMonth] = useState(new Date().getMonth());
  const [assessmentCalendarYear, setAssessmentCalendarYear] = useState(new Date().getFullYear());
   const [no_submit_evaluation_response, setSubmitEvaluationResponse] = useState(true);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitType, setSubmitType] = useState('');
  const [initialTotalLicenses, setInitialTotalLicenses] = useState(0);

  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedComment, setSelectedComment] = useState([]);
  const [selectedActivityName, setSelectedActivityName] = useState("");
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  });

  const [currentDate, setCurrentDate] = useState(() => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  });
  const [totalEngagementCount, setTotalEngagementCount] = useState(0);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [evaluationData, setEvaluationData] = useState([]);
  const [mainIndex, setMainIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [isEditable, setIsEditable] = useState(false);
  const {
    partnerEngagementCategoryList } = useAppSelector(
      (state) => state.partner_engagementConfiguration
    );

  const {
    eventPointSummary,
    eventPointDraftSummary,
    lastDraftFormFieldsByPartner,
    status: {
      submitEvaluationConfigurationLoading,
      evaluationMessage,
      evaluationSuccess
    } } = useAppSelector(
      (state) => state.partner_program_event_configuration
    );
  //comment for static data
  const { partnerRegionalMultiplierList,

  } = useAppSelector((state) => state.partner_regionalmultiplier);
  const { partnerDetails } = useAppSelector((state) => state.partner_details);


  const {
    partnerTierList,
    status: { partnerTierListLoading, deletePartnerTierLoading },
  } = useAppSelector((state) => state.partner_program);

  const { partnerLicenceList } = useAppSelector(
    (state) => state.partner_licenceProgram
  );

  const { consentStatus } = useAppSelector(
    (state) => state.partner_program
  );
  const { userDetail } = useAppSelector((state) => state.user);
  /** Session user (HID admin login); `state.user.userDetail` is often unset here — see reports-list. */
  const { loggedUserDetail } = useAppSelector((state) => state.auth);
  const optedIn = consentStatus?.consent_type === 'OptIn';
    useEffect(() => {
    if (!optedIn || readOnly) {
      setIsEditable(false);
      setShowAssessmentDatePicker(false);
      setShowAssessmentCalendar(false);
      setShowDatePicker(false);
      setShowCalendar(false);
    }
  }, [optedIn, readOnly]);

  // Prevent mouse wheel and arrow keys from changing number input values
  useEffect(() => {
    const preventWheel = (e: WheelEvent) => {
      e.preventDefault();
      (e.target as HTMLInputElement).blur();
    };
    const netEl = netNewLicensesInputRef.current;
    const totalEl = totalLicensesInputRef.current;
    if (netEl) {
      netEl.addEventListener('wheel', preventWheel, { passive: false });
    }
    if (totalEl) {
      totalEl.addEventListener('wheel', preventWheel, { passive: false });
    }
    return () => {
      if (netEl) netEl.removeEventListener('wheel', preventWheel);
      if (totalEl) totalEl.removeEventListener('wheel', preventWheel);
    };
  }, []);

  useEffect(() => {

    if (partnerRegionalMultiplierList && partnerRegionalMultiplierList.length) {

      const existResult = partnerRegionalMultiplierList.find((p_data) => {
        return p_data.region_code === partnerDetails.region
      })

      if (existResult && existResult.value) {
        formData.regionalModifier = existResult.value;
        setFormData({
          ...formData,
          regionalModifier: existResult.value || 1
        })
      }
    }

  }, [partnerRegionalMultiplierList])



  useEffect(() => {
    // Prefer draft summary when available so saved draft is shown when returning to the calculator tab
    const hasDraft = eventPointDraftSummary?.record?.length && eventPointDraftSummary?.summary;
    const source = hasDraft ? eventPointDraftSummary : eventPointSummary;

    const engData = structuredClone(partnerEngagementCategoryList);
    let count=0;
    if (engData && engData.length) {

      engData.forEach((e_data: any) => {
        if (e_data.engagements && e_data.engagements.length) {
          // Filter out inactive engagements
          e_data.engagements = e_data.engagements.filter((engagement: any) => engagement.status === "Active");
          count=count+e_data.engagements.length;
          e_data.engagements.forEach((dp_data: any) => {
            
            if (dp_data && dp_data.accelerator_value && dp_data.accelerator_value.length) {
              dp_data.selectedValue = dp_data.accelerator_value[0]['option_value']
              const existResult = calculatePotienalImprovementFn(dp_data.accelerator_value, dp_data.selectedValue)
              dp_data.potential_improvement = existResult;
            }


            if (source && source.record &&
              source.record.length &&
              source.record[0] &&

              source.record[0].engagements
            ) {



              const existSummaryResponse = source.record[0].engagements.find((s_data: any) => {

                return s_data.activity_id === dp_data.ID && s_data.category_id === dp_data.category_id

              })



              if (existSummaryResponse) {
                dp_data.selectedValue = existSummaryResponse.activity_value
                dp_data.potential_improvement = existSummaryResponse.potential_improvement
                dp_data.comment = existSummaryResponse.comment || []
                  dp_data.action = existSummaryResponse.action
              }
            }

          })
        }
      })
    }

    let sumPotentialImprovement = 0;
    if (engData && engData.length) {
      engData.forEach((e_data: any) => {
        e_data.engagements?.forEach((dp: any) => {
          sumPotentialImprovement += Number(dp.potential_improvement) || 0;
        });
      });
    }

    setEvaluationData(engData)
    //get lic points
    setTotalEngagementCount(count)

    if (source && source.summary) {


      //get default registered tier from settings

      const existData = partnerTierList && partnerTierList.length && partnerTierList.find((t_data) => {
        return t_data.tier_name === 'Registered'
      })

      const apiTotalLicenses =
        source?.record[0]?.partner_total_licenses || 0;
      const recordRow = source?.record?.[0];
      const netNewNum = Number(recordRow?.partner_new_licenses) || 0;
      let potentialPointsResolved = 0;
      if (recordRow?.engagements?.length) {
        potentialPointsResolved = sumPotentialImprovement * netNewNum;
      } else if (recordRow != null) {
        potentialPointsResolved =
          (Number(recordRow.potential_improvement) || 0) * netNewNum;
      } else {
        potentialPointsResolved =
          (Number(source?.summary?.potential_improvement?.value) || 0) *
          netNewNum;
      }

      setInitialTotalLicenses(apiTotalLicenses);

      const calculatedExtraPoints =
        getExtraPointsBasedOnNewLicense(apiTotalLicenses);

      // Support multiple API response shapes (snake_case, camelCase, top-level) for dates and comment.
      // Fall back to last saved draft fields (Redux) when API doesn't return them (e.g. draft summary endpoint).
      const rec = source?.record?.[0] ?? source;
      const storedDraft = partnerDetails?.ID ? lastDraftFormFieldsByPartner[partnerDetails.ID] : undefined;
      const assessmentDate =
        rec?.assessment_date ?? rec?.assessmentDate ?? source?.assessment_date ?? source?.assessmentDate
        ?? storedDraft?.assessment_date;
      const nextAssessmentDate =
        rec?.next_assessment_date ?? rec?.nextAssessmentDate ?? source?.next_assessment_date ?? source?.nextAssessmentDate
        ?? storedDraft?.next_assessment_date;
      const recordComment =
        (rec?.comments && rec.comments[0] && (rec.comments[0].comment ?? rec.comments[0].Comment)) ??
        rec?.comment ??
        (source?.comments && source.comments[0] && (source.comments[0].comment ?? source.comments[0].Comment)) ??
        source?.comment ??
        storedDraft?.comment ??
        '';

      setFormData(prev => ({
        ...prev,
        currentTier: source?.summary?.tier?.name || 'Registered',
        totalPoints: source?.summary?.partner_points?.value || 0,
        pointsToNextTier:
          source?.summary?.next_tier_progress?.value?.points_required || 0,
        licencesToNextTier:
          source?.summary?.next_required_license?.value?.licenses_required || 0,
        documents: source?.record[0]?.documents || [],
        potentialPoints: potentialPointsResolved,
        netNewLicenses:
          source?.record[0]?.partner_new_licenses || 0,
        totalLicenses: apiTotalLicenses,
        extraPoints: calculatedExtraPoints,   // ✅ THIS WAS MISSING
        totalMultiplier:
          source?.record[0]?.total_multiplier || prev.regionalModifier,
        tier_id: source?.summary?.tier?.value || 0,
        comment: recordComment,
      }));
      setNetNewLicensesDisplay(null);
      setNewDocuments([])
      getExtraPointsBasedOnNewLicense(source?.record[0]?.partner_total_licenses || 0);

      // Restore assessment dates so they persist when returning to the tab (support multiple API key shapes)
      if (assessmentDate) {
        setCurrentDate(assessmentDate);
      }
      if (nextAssessmentDate) {
        setSelectedDate(nextAssessmentDate);
      }
// getTotalMultiplierValueFn();
    }
    
    else {
      const existData = partnerTierList && partnerTierList.length && partnerTierList.find((t_data) => {
        return t_data.tier_name === 'Registered'
      })
      setFormData({
        ...formData,
        currentTier: existData && existData != null ? existData.tier_name : 'Registered',
        tier_id: existData && existData != null ? existData.ID : 0,
        totalMultiplier:formData.regionalModifier
      })

    }

    //getTotalMultiplierValueFn()

  }, [partnerEngagementCategoryList, eventPointSummary, eventPointDraftSummary, lastDraftFormFieldsByPartner, partnerDetails?.ID])

  const calculatePotienalImprovementFn = (engagementData: any, selectedValue: any, mainIndex?: number,
    subIndex?: number
  ) => {

    if (mainIndex >= 0 && subIndex >= 0) {
      if (engagementData && engagementData.length) {
        const maxValue = Math.max(...engagementData.map((o: { option_value: any; }) => o.option_value))

        const eData = evaluationData;
        eData[mainIndex]['engagements'][subIndex]['selectedValue'] = selectedValue;
        eData[mainIndex]['engagements'][subIndex]['potential_improvement'] = (Number(maxValue) - Number(selectedValue)).toFixed(2);

        setEvaluationData([...eData])
      }
    } else {
      if (engagementData && engagementData.length) {
        const maxValue = Math.max(...engagementData.map((o: { option_value: any; }) => o.option_value))
        return (Number(maxValue) - Number(selectedValue)).toFixed(2);

      }
    }



  }

  const getExtraPointsBasedOnNewLicense = (totalLicenses: number) => {
    if (!partnerLicenceList?.length) return 0;

    const sorted = [...partnerLicenceList].sort(
      (a, b) => a.license_count - b.license_count
    );

    for (let i = sorted.length - 1; i >= 0; i--) {
      if (totalLicenses >= sorted[i].license_count) {
        return sorted[i].points;
      }
    }

    return 0;
  };

  const getTotalMultiplierValueFn = () => {

    //get total multipier
    let totalAmount = 0;
    let sumPotentialImprovement = 0;
    evaluationData.forEach((e_data: any) => {
      if (e_data && e_data.engagements) {
        e_data.engagements.forEach((currentValue: any) => {
          totalAmount += Number(currentValue.selectedValue);
          sumPotentialImprovement += Number(currentValue.potential_improvement) || 0;
        });
      }
    });

    const totalMultiper = totalAmount + formData.regionalModifier;
    const potientialImprovement =
      sumPotentialImprovement * Number(formData.netNewLicenses);

    const totalPoint =
      ((Number(formData.netNewLicenses) + 10) * totalMultiper) +
      (formData.extraPoints * formData.regionalModifier);

   
    setFormData({
      ...formData,
      totalPoints: totalPoint,
      totalMultiplier: totalMultiper,
      potentialPoints: potientialImprovement,
    })






  }



  useEffect(() => {
    if (partnerDetails?.ID) {
      // Prevent stale summary/draft from previous partner from flashing in UI while new fetch is in-flight.
      dispatch(partnerProgramEventConfigurationSliceAction.clearPartnerPointsSummaries());
      dispatch(getPartnerPointsSummary(partnerDetails.ID));
      dispatch(getPartnerPointsDraftSummary(partnerDetails.ID));
    }
  }, [partnerDetails?.ID])

  // Restore Assessment Day, Next Assessment Date, and Comment from last saved draft (Redux)
  // when we have draft data for this partner so they stick after tab/page switch.
  useEffect(() => {
    const partnerId = partnerDetails?.ID;
    if (partnerId == null) return;
    const stored = lastDraftFormFieldsByPartner[partnerId];
    if (!stored) return;
    const hasDraftRecord =
      (eventPointDraftSummary?.record && eventPointDraftSummary.record.length > 0) ||
      (Array.isArray(eventPointDraftSummary) && eventPointDraftSummary.length > 0);
    if (!hasDraftRecord) return;
    if (stored.assessment_date) setCurrentDate(stored.assessment_date);
    if (stored.next_assessment_date) setSelectedDate(stored.next_assessment_date);
    if (stored.comment !== undefined && stored.comment !== null) {
      setFormData((prev) => ({ ...prev, comment: stored.comment ?? '' }));
    }
  }, [partnerDetails?.ID, lastDraftFormFieldsByPartner, eventPointDraftSummary])

  const handleInputChange = (field: string, value: any) => {
    if (field === 'netNewLicenses' || field === 'totalLicenses') {
      if (value < 0) {
        setFormData((prev) => ({ ...prev, [field]: 0 }));
      } else {
        setFormData((prev) => ({ ...prev, [field]: value }));
      }
      if(field === 'totalLicenses'){
    getExtraPointsBasedOnNewLicense(value)
      }
   
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }

  };

  const handleNetNewLicensesChange = (value: string | number) => {
    const isEmpty = value === '' || (typeof value === 'string' && value.trim() === '');
    const numericValue = isEmpty ? 0 : Math.max(0, Number(value) || 0);
    const calculatedTotalLicenses = initialTotalLicenses + numericValue;
    const extraPoints = getExtraPointsBasedOnNewLicense(calculatedTotalLicenses);

    setNetNewLicensesDisplay(isEmpty ? '' : null);
    setFormData(prev => ({
      ...prev,
      netNewLicenses: numericValue,
      totalLicenses: calculatedTotalLicenses,
      extraPoints,
    }));
  };

  const handleTotalLicensesChange = (value: string | number) => {
    const safeValue = Math.max(0, Number(value) || 0);

    const extraPoints = getExtraPointsBasedOnNewLicense(safeValue);

    setFormData(prev => ({
      ...prev,
      totalLicenses: safeValue,
      extraPoints,
    }));
  };

  useEffect(() => {
    if (!isEditable) return;

    getTotalMultiplierValueFn();
  }, [
    formData.netNewLicenses,
    formData.extraPoints,
    evaluationData,
    formData.regionalModifier,
    isEditable,
  ]);

  /** Read-only: API summary `potential_improvement` is the per-activity sum; display = sum × net new (same as after submit). */
  useEffect(() => {
    if (isEditable) return;
    if (!partnerEngagementCategoryList?.length) return;

    let sumPotentialImprovement = 0;
    evaluationData.forEach((e_data: any) => {
      if (e_data && e_data.engagements) {
        e_data.engagements.forEach((currentValue: any) => {
          sumPotentialImprovement +=
            Number(currentValue.potential_improvement) || 0;
        });
      }
    });

    setFormData((prev) => {
      const netNew = Number(prev.netNewLicenses) || 0;
      const nextPotential = sumPotentialImprovement * netNew;
      if (prev.potentialPoints === nextPotential) return prev;
      return { ...prev, potentialPoints: nextPotential };
    });
  }, [
    isEditable,
    evaluationData,
    partnerEngagementCategoryList?.length,
  ]);

  const toggleEngagement = (key: string) => {
    if (key === oldExpandKey) {
      setExpanded('');
      setOldExpanded('');
    } else {
      setExpanded(key);
      setOldExpanded(key);
    }

  };

  const isDatePast = (year: number, month: number, day: number) => {
    const d = new Date(year, month, day);
    const today = new Date();
    d.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return d < today;
  };

  const handleDateSelect = (day: number, isCurrentMonth: boolean, isDisabled?: boolean) => {
    if (isDisabled) return;

    let selectedMonth = currentMonth;
    let selectedYear = currentYear;

    if (!isCurrentMonth) {
      // If day belongs to previous month
      if (day > 20) {
        selectedMonth = currentMonth - 1;
        if (selectedMonth < 0) {
          selectedMonth = 11;
          selectedYear -= 1;
        }
      }
      // If day belongs to next month
      else {
        selectedMonth = currentMonth + 1;
        if (selectedMonth > 11) {
          selectedMonth = 0;
          selectedYear += 1;
        }
      }
    }

    if (isDatePast(selectedYear, selectedMonth, day)) return;

    const month = String(selectedMonth + 1).padStart(2, "0");
    const formattedDay = String(day).padStart(2, "0");

    const dbDate = `${selectedYear}-${month}-${formattedDay}`;

    setSelectedDate(dbDate);
    setCurrentMonth(selectedMonth);
    setCurrentYear(selectedYear);

    setShowDatePicker(true);
    setShowCalendar(false);
  };

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleCalendarToggle = () => {
    if (showCalendar) {
      // Close calendar
      setShowCalendar(false);
    } else {
      // Open calendar
      setShowCalendar(true);
    }
  };

  const handleSetDateClick = () => {
    setShowDatePicker(true);
    setShowCalendar(true);
  };

  // Handle outside click to close calendar
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target as Node) &&
        showCalendar
      ) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  // Handle outside click to close assessment day calendar
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        assessmentDatePickerRef.current &&
        !assessmentDatePickerRef.current.contains(event.target as Node) &&
        showAssessmentCalendar
      ) {
        setShowAssessmentCalendar(false);
      }
    };

    if (showAssessmentCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAssessmentCalendar]);




  // Calendar helper
  const generateCalendar = () => {
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDay = new Date(currentYear, currentMonth, 1).getDay();
    const days: { day: number; isCurrentMonth: boolean; isSelected: boolean; isDisabled: boolean }[] = [];

    const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();

    // Previous month days
    for (let i = firstDay - 1; i >= 0; i--) {
      const d = prevMonthDays - i;
      days.push({
        day: d,
        isCurrentMonth: false,
        isSelected: false,
        isDisabled: isDatePast(prevYear, prevMonth, d),
      });
    }

    // Current month days (selectedDate format: YYYY-MM-DD)
    const [selYear, selMonth, selDay] = selectedDate.split("-").map(Number);
    const selectedDay = selDay;
    const selectedMonth = (selMonth || 1) - 1;
    const selectedYear = selYear || new Date().getFullYear();

    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        day: i,
        isCurrentMonth: true,
        isSelected:
          i === selectedDay &&
          currentMonth === selectedMonth &&
          currentYear === selectedYear,
        isDisabled: isDatePast(currentYear, currentMonth, i),
      });
    }

    // Next month days
    const nextMonth = currentMonth === 11 ? 0 : currentMonth + 1;
    const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
    const remainingDays = 42 - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      days.push({
        day: i,
        isCurrentMonth: false,
        isSelected: false,
        isDisabled: isDatePast(nextYear, nextMonth, i),
      });
    }

    return days;
  };

  const getMonthName = (month: number) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[month];
  };

  // Assessment Day datepicker handlers (allows past dates)
  const handleAssessmentDateSelect = (day: number, isCurrentMonth: boolean, isDisabled?: boolean) => {
    if (isDisabled) return;

    let selectedMonth = assessmentCalendarMonth;
    let selectedYear = assessmentCalendarYear;

    if (!isCurrentMonth) {
      if (day > 20) {
        selectedMonth = assessmentCalendarMonth - 1;
        if (selectedMonth < 0) {
          selectedMonth = 11;
          selectedYear -= 1;
        }
      } else {
        selectedMonth = assessmentCalendarMonth + 1;
        if (selectedMonth > 11) {
          selectedMonth = 0;
          selectedYear += 1;
        }
      }
    }

    const month = String(selectedMonth + 1).padStart(2, "0");
    const formattedDay = String(day).padStart(2, "0");
    const dbDate = `${selectedYear}-${month}-${formattedDay}`;

    setCurrentDate(dbDate);
    setAssessmentCalendarMonth(selectedMonth);
    setAssessmentCalendarYear(selectedYear);
    setShowAssessmentDatePicker(true);
    setShowAssessmentCalendar(false);
  };

  const handleAssessmentPrevMonth = () => {
    if (assessmentCalendarMonth === 0) {
      setAssessmentCalendarMonth(11);
      setAssessmentCalendarYear(assessmentCalendarYear - 1);
    } else {
      setAssessmentCalendarMonth(assessmentCalendarMonth - 1);
    }
  };

  const handleAssessmentNextMonth = () => {
    if (assessmentCalendarMonth === 11) {
      setAssessmentCalendarMonth(0);
      setAssessmentCalendarYear(assessmentCalendarYear + 1);
    } else {
      setAssessmentCalendarMonth(assessmentCalendarMonth + 1);
    }
  };

  const handleAssessmentCalendarToggle = () => {
    if (showAssessmentCalendar) {
      setShowAssessmentCalendar(false);
    } else {
      setShowAssessmentCalendar(true);
    }
  };

  const handleSetAssessmentDateClick = () => {
    if (currentDate) {
      const [y, m] = currentDate.split("-").map(Number);
      setAssessmentCalendarMonth((m || 1) - 1);
      setAssessmentCalendarYear(y || new Date().getFullYear());
    } else {
      setAssessmentCalendarMonth(new Date().getMonth());
      setAssessmentCalendarYear(new Date().getFullYear());
    }
    setShowAssessmentDatePicker(true);
    setShowAssessmentCalendar(true);
  };

  const generateAssessmentCalendar = () => {
    const daysInMonth = new Date(assessmentCalendarYear, assessmentCalendarMonth + 1, 0).getDate();
    const firstDay = new Date(assessmentCalendarYear, assessmentCalendarMonth, 1).getDay();
    const days: { day: number; isCurrentMonth: boolean; isSelected: boolean; isDisabled: boolean }[] = [];

    const prevMonth = assessmentCalendarMonth === 0 ? 11 : assessmentCalendarMonth - 1;
    const prevYear = assessmentCalendarMonth === 0 ? assessmentCalendarYear - 1 : assessmentCalendarYear;
    const prevMonthDays = new Date(assessmentCalendarYear, assessmentCalendarMonth, 0).getDate();

    for (let i = firstDay - 1; i >= 0; i--) {
      const d = prevMonthDays - i;
      days.push({
        day: d,
        isCurrentMonth: false,
        isSelected: false,
        isDisabled: false,
      });
    }

    const parts = currentDate ? currentDate.split("-").map(Number) : [];
    const selectedDay = parts[2];
    const selectedMonth = parts[1] ? (parts[1] || 1) - 1 : -1;
    const selectedYear = parts[0] || new Date().getFullYear();

    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        day: i,
        isCurrentMonth: true,
        isSelected:
          !!currentDate &&
          i === selectedDay &&
          assessmentCalendarMonth === selectedMonth &&
          assessmentCalendarYear === selectedYear,
        isDisabled: false,
      });
    }

    const nextMonth = assessmentCalendarMonth === 11 ? 0 : assessmentCalendarMonth + 1;
    const nextYear = assessmentCalendarMonth === 11 ? assessmentCalendarYear + 1 : assessmentCalendarYear;
    const remainingDays = 42 - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      days.push({
        day: i,
        isCurrentMonth: false,
        isSelected: false,
        isDisabled: false,
      });
    }

    return days;
  };

  const submitEvaluationFn = (type: string) => {
    const loginUserId =
      loggedUserDetail?.ID ?? userDetail?.ID ?? 0;
    const submitterDisplayName =
      [loggedUserDetail?.first_name, loggedUserDetail?.last_name]
        .filter(Boolean)
        .join(" ")
        .trim() ||
      [userDetail?.first_name, userDetail?.last_name]
        .filter(Boolean)
        .join(" ")
        .trim() ||
      "Admin";

    let engagement: { activity_id: any; name: any; activity_key: string; activity_value: any; category_id: any; potential_improvement: any; comment: string; updated_by: number; action: string; }[] = [];

    if (evaluationData && evaluationData.length) {
      evaluationData.map((data) => {
        if (data && data.engagements && data.engagements.length) {
          data.engagements.map((e_data: any) => {
            engagement.push({
              "activity_id": e_data.ID,
              "name": e_data.activity_name,
              "activity_key": "Yes",
              "activity_value": e_data.selectedValue,
              "category_id": e_data.category_id,
              "potential_improvement": e_data.potential_improvement,
              "comment": e_data.comment,
              "updated_by": loginUserId,
              "action": "Approved"
            })
          })
        }

      })
    }


    const action = type === 'draft' ? 'draft' : 'submit';
    const payload = {
      partner_id: partnerDetails?.ID,
      tier_id: formData.tier_id,
      engagements: engagement,
      total_partner_points: Number(formData.totalPoints),
      documents:formData.documents,
      "license_points": Number(formData.licencesToNextTier),
      "partner_new_licenses": Number(formData.netNewLicenses),
      "partner_total_licenses": Number(formData.totalLicenses),
      "total_multiplier": formData.totalMultiplier,
      "updated_by": loginUserId,
      "status": type==='draft' ? 'Inactive' : "Active",
      "event_type": type,
      "action": action,
      "potential_improvement": formData.potentialPoints,
      "comments": [
        {
          "role": "Admin",
          "commented_by": submitterDisplayName,
          "comment": formData.comment
        }
      ],
      "assessment_date": currentDate || (() => {
        const t = new Date();
        return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
      })(),
      "next_assessment_date": selectedDate,
    }

    if (newDocuments && newDocuments.length) {
      const formData = new FormData();
      newDocuments.map((d_data: any) => {
        formData.append('documents', d_data)
      })

      Object.keys(payload).forEach((key) => {
        const value = payload[key as keyof {
          partner_id: number;
          tier_id: number;
          engagements: {
            activity_id: any;
            name: any;
            activity_key: string;
            activity_value: any;
            category_id: any;
            potential_improvement: any;
            comment: string;
            updated_by: number;
            action: string;
          }[];
          documents: any[];
          total_partner_points: number;
          license_points: number;
          partner_new_licenses: number;
          partner_total_licenses: number;
          total_multiplier: number;
          updated_by: number;
          status: string;
          event_type: string;
          action: string;
          potential_improvement: number;
          comments: {
            role: string;
            commented_by: string;
            comment: string;
          }[];
          assessment_date: string;
          next_assessment_date: string;
        }];

        // Skip file fields if they are File objects (already appended above)


        // Skip null/undefined values
        if (value === null || value === undefined) {
          return;
        }

        // For nested objects and arrays, stringify them
        // For primitive values (strings, numbers, booleans), append directly
        //if (typeof value === 'object' || !Array.isArray(value))
        if ((typeof value === 'object' && value !== null) || Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, String(value));
        }
      });

      if (type === 'draft') {
        dispatch(SaveDraft(formData))
      } else {
        dispatch(AddCalculator(formData))
      }
    } else {
      if (type === 'draft') {
        dispatch(SaveDraft(payload))
      } else {
        dispatch(AddCalculator(payload))
      }

    }


    setSubmitted(true)
    //setConfirmationOpen(false)

  }

  const [newDocuments, setNewDocuments] = useState([]);
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      console.log("event.target.files=>", event.target.files)
      const files = Array.from(event.target.files);
      setNewDocuments((prev: any) => [...prev, ...files]);
    }
  };

  const handleRemoveDocument = (index: number) => {
    setNewDocuments((prev: any) => prev.filter((_: any, i: number) => i !== index));
  };

  const handleViewFile = (fileName: string) => {
    dispatch(getFileUrl(fileName, "view"));
  };

  const handleViewNewDocument = (file: File) => {
    const fileUrl = URL.createObjectURL(file);
    window.open(fileUrl, "_blank");
    URL.revokeObjectURL(fileUrl);
  };

  const handleRemoveOldDocument = (index: number) => {
    const formDataValue = structuredClone(formData);
    formDataValue.documents.splice(index, 1);
    setFormData({ ...formDataValue });
  };

  const setCommentEngagementWise=(commentData:any)=>{

    console.log("commentData",commentData)

    let cData = structuredClone(evaluationData);
    cData[mainIndex]['engagements'][subIndex]['comment']=commentData;

    setEvaluationData(cData)

  }

  const todayYmd = () => {
    const t = new Date();
    return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
  };

  const handleResetEditableFields = () => {
    if (!isEditable || !optedIn) return;

    const ymd = todayYmd();
    setCurrentDate(ymd);
    setSelectedDate(ymd);
    setCurrentMonth(new Date().getMonth());
    setCurrentYear(new Date().getFullYear());
    setAssessmentCalendarMonth(new Date().getMonth());
    setAssessmentCalendarYear(new Date().getFullYear());

    setShowAssessmentDatePicker(false);
    setShowAssessmentCalendar(false);
    setShowDatePicker(false);
    setShowCalendar(false);

    setNetNewLicensesDisplay(null);
    setNewDocuments([]);

    const engData = structuredClone(partnerEngagementCategoryList) as any[];
    let count = 0;
    if (engData && engData.length) {
      engData.forEach((e_data: any) => {
        if (e_data.engagements && e_data.engagements.length) {
          e_data.engagements = e_data.engagements.filter(
            (engagement: any) => engagement.status === "Active"
          );
          count += e_data.engagements.length;
          e_data.engagements.forEach((dp_data: any) => {
            if (dp_data?.accelerator_value?.length) {
              dp_data.selectedValue = dp_data.accelerator_value[0].option_value;
              dp_data.potential_improvement = calculatePotienalImprovementFn(
                dp_data.accelerator_value,
                dp_data.selectedValue
              );
            }
            dp_data.comment = [];
            delete dp_data.action;
          });
        }
      });
    }

    setEvaluationData(engData);
    setTotalEngagementCount(count);

    const extraPts = getExtraPointsBasedOnNewLicense(0);

    setFormData((prev) => {
      let totalAmount = 0;
      let sumPotentialImprovement = 0;
      engData.forEach((e_data: any) => {
        if (e_data?.engagements) {
          e_data.engagements.forEach((currentValue: any) => {
            totalAmount += Number(currentValue.selectedValue) || 0;
            sumPotentialImprovement += Number(currentValue.potential_improvement) || 0;
          });
        }
      });
      const totalMultiper = totalAmount + prev.regionalModifier;
      const potentialPts = sumPotentialImprovement * 0;
      const totalPoint = 10 * totalMultiper + extraPts * prev.regionalModifier;
      return {
        ...prev,
        netNewLicenses: 0,
        totalLicenses: 0,
        extraPoints: extraPts,
        comment: "",
        documents: [],
        totalPoints: totalPoint,
        totalMultiplier: totalMultiper,
        potentialPoints: potentialPts,
      };
    });
  };



  return (
    <>
    <div className="calculator-container">

      {/* Info Banner */}
      <div className="info-banner">
               <div className="left">
          <Iconography
            icon="circleInfo"
            size={IconographySizes.Small}
            className="info-icon"
          />
          <span className="info-text">
            <strong>Info</strong> This calculations shown are{" "}
            <strong>based on ongoing assessment</strong>
          </span>
        </div>
        <div className="info-banner-actions">
          {isEditable ? 
            <>
              <Button
                variant="secondary"
                label="Reset"
                normalCase={true}
                onClick={handleResetEditableFields}
                disabled={readOnly}
              />
              <Button
                variant="secondary"
                label="Save"
                normalCase={true}
                onClick={() => {
                  setConfirmationOpen(true);
                  setSubmitType('draft');
                }}
                disabled={readOnly}
              />
              <Button 
                variant="secondary" 
                label="Cancel"
                normalCase={true} 
                disabled={readOnly}
                onClick={() => {
                  setIsEditable(false);
                  setShowAssessmentDatePicker(false);
                  setShowAssessmentCalendar(false);
                  setShowDatePicker(false);
                  setShowCalendar(false);
                }}
              />
            </>
            :
            <Button 
              variant="secondary" 
              label="Edit" 
              disabled={!optedIn || readOnly} 
              icon={<Iconography icon="pen" size={IconographySizes.Small} />}
              normalCase={true} 
              onClick={() => {
                if (!readOnly) setIsEditable(true);
              }}
            />
          }
        </div>

      </div>
      {/* Header */}
      <div className="calculator-header">
        <div className="header-left">
          <h1>Assessment Day</h1>
          {!showAssessmentDatePicker ? (
            <button
              className="set-assessment-btn"
              onClick={isEditable ? handleSetAssessmentDateClick : undefined}
              type="button"
              title="Select assessment date"
              disabled={!isEditable}
            >
              {currentDate ? (
                <span className="assessment-date-value">{new Date(currentDate).toLocaleDateString()}</span>
              ) : null}
              <Iconography icon="calendar" size={IconographySizes.Small} />
            </button>
          ) : (
            <div className="date-picker-wrapper" ref={assessmentDatePickerRef}>
              <div className="date-input-group">
                <input
                  type="text"
                  value={currentDate ? new Date(currentDate).toLocaleDateString() : ""}
                  placeholder="Select date"
                  readOnly
                  className="date-input"
                  onClick={isEditable ? handleAssessmentCalendarToggle : undefined}
                  style={{ cursor: isEditable ? "pointer" : "default" }}
                />
                <button
                  type="button"
                  className="calendar-btn"
                  onClick={isEditable ? handleAssessmentCalendarToggle : undefined}
                  disabled={!isEditable}
                >
                  <Iconography icon="calendar" size={IconographySizes.Small} />
                </button>
              </div>

              {showAssessmentCalendar && (
                <div className="calendar-popup">
                  <div className="calendar-header">
                    <button className="nav-btn" onClick={handleAssessmentPrevMonth}>
                      <Iconography
                        icon="chevronLeft"
                        size={IconographySizes.Small}
                      />
                    </button>
                    <span className="month-year">
                      {getMonthName(assessmentCalendarMonth)} {assessmentCalendarYear}
                    </span>
                    <button className="nav-btn" onClick={handleAssessmentNextMonth}>
                      <Iconography
                        icon="chevronRight"
                        size={IconographySizes.Small}
                      />
                    </button>
                  </div>
                  <div className="calendar-weekdays">
                    {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
                      <div key={day} className="weekday">
                        {day}
                      </div>
                    ))}
                  </div>
                  <div className="calendar-days">
                    {generateAssessmentCalendar().map((dayObj, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`calendar-day ${!dayObj.isCurrentMonth ? "other-month" : ""
                          } ${dayObj.isSelected ? "selected" : ""} ${dayObj.isDisabled ? "disabled" : ""}`}
                        onClick={() =>
                          handleAssessmentDateSelect(dayObj.day, dayObj.isCurrentMonth, dayObj.isDisabled)
                        }
                        disabled={dayObj.isDisabled}
                      >
                        {dayObj.day}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="header-actions">
          <span className="assessment-date-label">SET NEXT ASSESSMENT DATE</span>
          {!showDatePicker ? (
            <button
              className="set-assessment-btn"
              onClick={isEditable ? handleSetDateClick : undefined}
              type="button"
              title="Select next assessment date"
              disabled={!isEditable}
            >
              {selectedDate ? (
                <span className="assessment-date-value">{new Date(selectedDate).toLocaleDateString()}</span>
              ) : null}
              <Iconography icon="calendar" size={IconographySizes.Small} />
            </button>
          ) : (
            <div className="date-picker-wrapper" ref={datePickerRef}>
              <div className="date-input-group">
                <input
                  type="text"
                  value={new Date(selectedDate).toLocaleDateString()}
                  readOnly
                  className="date-input"
                  onClick={isEditable ? handleCalendarToggle : undefined}
                  style={{ cursor: isEditable ? "pointer" : "default" }}
                />
                <button
                  type="button"
                  className="calendar-btn"
                  onClick={isEditable ? handleCalendarToggle : undefined}
                  disabled={!isEditable}
                >
                  <Iconography icon="calendar" size={IconographySizes.Small} />
                </button>
              </div>

              {showCalendar && (
                <div className="calendar-popup">
                  <div className="calendar-header">
                    <button className="nav-btn" onClick={handlePrevMonth}>
                      <Iconography
                        icon="chevronLeft"
                        size={IconographySizes.Small}
                      />
                    </button>
                    <span className="month-year">
                      {getMonthName(currentMonth)} {currentYear}
                    </span>
                    <button className="nav-btn" onClick={handleNextMonth}>
                      <Iconography
                        icon="chevronRight"
                        size={IconographySizes.Small}
                      />
                    </button>
                  </div>
                  <div className="calendar-weekdays">
                    {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
                      <div key={day} className="weekday">
                        {day}
                      </div>
                    ))}
                  </div>
                  <div className="calendar-days">
                    {generateCalendar().map((dayObj, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`calendar-day ${!dayObj.isCurrentMonth ? "other-month" : ""
                          } ${dayObj.isSelected ? "selected" : ""} ${dayObj.isDisabled ? "disabled" : ""}`}
                        onClick={() =>
                          handleDateSelect(dayObj.day, dayObj.isCurrentMonth, dayObj.isDisabled)
                        }
                        disabled={dayObj.isDisabled}
                      >
                        {dayObj.day}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>


      {/* Main Content */}
      <div className="calculator-content">
        {/* Summary Section */}
        <div className="calc-section">
          <h2 className="section-title">Summary</h2>
          <div className="section-content">
            <div className="summary-grid">
              <div className="summary-item tier">
                <div className="item-left">
                  <Iconography
                    icon="award"
                    size={IconographySizes.Small}
                    className="item-icon"
                  />
                  <span className="item-label">Current Tier</span>
                </div>
                <span className="item-value">{formData.currentTier}</span>
              </div>

              <div className="summary-item points">
                <div className="item-left">
                  <Iconography
                    icon="arrowTrendUp"
                    size={IconographySizes.Small}
                    className="item-icon"
                  />
                  <span className="item-label">Total Points</span>
                </div>
                <span className="item-value">{Math.round(formData.totalPoints)}</span>
              </div>

              <div className="summary-item next-tier">
                <div className="item-left">
                  <Iconography
                    icon="circlePlus"
                    size={IconographySizes.Small}
                    className="item-icon"
                  />
                  <span className="item-label">Points to next Tier</span>
                </div>
                <span className="item-value">
                  {/* {formData.pointsToNextTier.toFixed(2)} */}
                  {formData.pointsToNextTier}
                </span>
              </div>

              <div className="summary-item licenses">
                <div className="item-left">
                  <Iconography
                    icon="circleStar"
                    size={IconographySizes.Small}
                    className="item-icon"
                  />
                  <span className="item-label">licences to next Tier</span>
                </div>
                <span className="item-value">
                  {/* {formData.licencesToNextTier.toFixed(2)} */}
                  {formData.licencesToNextTier}
                </span>
              </div>

              <div className="summary-item potential">
                <div className="item-left">
                  <Iconography
                    icon="fileCheck"
                    size={IconographySizes.Small}
                    className="item-icon"
                  />
                  <span className="item-label">Potential Points</span>
                </div>
                <span className="item-value">
                  {Number(formData.potentialPoints ?? 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Licenses Section */}
        <div className="calc-section">
          <h2 className="section-title">Licenses</h2>
          <div className="section-content">
            <div className="form-field">
              <label>Net New Licenses</label>
              <input
                ref={netNewLicensesInputRef}
                className="hide-number-spinner"
                type="number"
                min={0}

                value={netNewLicensesDisplay !== null ? netNewLicensesDisplay : formData.netNewLicenses}
                onChange={(e) => {
                  handleNetNewLicensesChange(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
                }}
                                readOnly={!isEditable}

              />
            </div>
            <div className="form-field">
              <label>Total Licenses</label>
              <input
                ref={totalLicensesInputRef}
                className="hide-number-spinner"
                type="number"
                value={formData.totalLicenses}
                onChange={(e) => handleTotalLicensesChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
                }}
                onBlur={()=>{getTotalMultiplierValueFn()}}
                readOnly={!isEditable}
              />
            </div>
          </div>
        </div>

        {/* Points Accelerators Section */}
        <div className="calc-section">
          <h2 className="section-title">Points Accelerators</h2>
          <div className="section-content">
            <div className="form-field">
              <label>Extra Points Based on Total Licenses</label>
              <input
                type="number"
                value={formData.extraPoints}
                disabled

              />
            </div>
            <div className="form-field">
              <label>Regional Modifier</label>
              <input
                type="text"
                value={formData.regionalModifier}

                disabled
              />
            </div>
            <div className="form-field">
              <label>Total Multiplier</label>
              <input
                type="text"
                value={formData.totalMultiplier.toFixed(2)}

                disabled
              />
            </div>
          </div>
        </div>

        {/* Engagement Activities Section */}
        <div className="engagement-section">
          <div className="section-header">
            <div>
              <span className="section-title">Engagement Activities</span>
              <span className="section-subtitle">
                Configure Activity Points
              </span>
            </div>
            <div className="activity-badges">
              <span className="badge total">Total: {totalEngagementCount || 0}</span>
              <span className="badge done">Done: {totalEngagementCount || 0}</span>
              <span className="badge pending">Pending: 0</span>
            </div>
          </div>
          <div className="engagement-list">
            {evaluationData && evaluationData != null &&
              evaluationData.map((activity: any, main_index: number) => (
                <>
                  {activity.engagements && activity.engagements.length ?
                    <div key={activity.category_name} className="engagement-wrapper">
                      <div
                        className={`engagement-item ${expanded === activity.category_name ? "expanded" : ""
                          }`}
                        onClick={() => toggleEngagement(activity.category_name)}
                      >
                        <div className="item-left">
                          <div className="title-wrapper">
                            <span className="item-title">{activity.category_name}</span>
                            {/* {activity.count && (
                        <span className="red-badge">{2}</span>
                      )} */}
                            {/* <span className="red-badge">{2}</span> */}
                          </div>
                        </div>
                        <Iconography
                          icon={expanded === activity.category_name ? "chevronUp" : "chevronDown"}
                          size={IconographySizes.Small}
                          className="chevron-icon"
                        />
                      </div>

                      {/* Expanded Content - Marketing Engagement Table */}
                      {expanded === activity.category_name &&
                        <div className="engagement-content">
                          <div className="engagement-table">
                            <div className="table-header">
                              <div className="th th-activity">Activity Name</div>
                              <div className="th th-description">Description</div>
                              <div className="th th-level">Level</div>
                              <div className="th th-accelerator">Accelerator</div>
                              <div className="th th-potential">Potential</div>
                              <div className="th th-comment">Comment</div>
                              {/* <div className="th th-action">
                                Action
                                <div className="info-icon-wrapper">
                                  <Iconography
                                    icon="circleInfo"
                                    size={IconographySizes.Small}
                                    className="info-icon"
                                  />
                                  <div className="info-tooltip">
                                    Accept or reject partner filled information
                                  </div>
                                </div>
                              </div> */}
                            </div>
                            <div className="table-body">
                              {activity.engagements && activity.engagements.length ?
                                activity.engagements.map((item: any, index: any) => (
                                  <div key={index} className="table-row">
                                    <div className="td td-activity">{item.activity_name}</div>
                                    <div className="td td-description">
                                      <ActivityDescriptionLink
                                        activityName={item.activity_name}
                                        description={item.description}
                                        onView={({ activityName, description }) => {
                                          setSelectedActivityName(activityName || "");
                                          setSelectedDescription(description || "");
                                          setShowDescriptionModal(true);
                                        }}
                                      />
                                    </div>
                                    <div className="td td-level">
                                      {/* <select className="level-select" key={item.activity_name}>
                                {item.accelerator_value && item.accelerator_value.length ? 
                                item.accelerator_value.map((a_data:any,index:number)=>(
<option key={index}>{a_data.option_key}</option>
                                )):
                                <option>No data</option>
                              }
                                
                              </select> */}


                                      <Select
                                        className="selctWd"
                                        value={item.selectedValue}
                                        onChange={(e) => {
                                          calculatePotienalImprovementFn(item.accelerator_value, e.target.value, main_index, index

                                          )
                                          getTotalMultiplierValueFn()
                                        }}
                                        disabled={!isEditable}

                                        //abelId="country-name-label"
                                        id={""}                                //value={form.country}
                                      >



                                        {item.accelerator_value && item.accelerator_value.length ?
                                          item.accelerator_value.map((a_data: any, ind: number) => (

                                            <MenuItem key={ind}

                                              value={a_data.option_value}>
                                              {a_data.option_key}
                                            </MenuItem>
                                          )) :
                                          <MenuItem>No Data</MenuItem>
                                        }
                                      </Select>

                                    </div>
                                    <div className="td td-accelerator">
                                      {item.selectedValue}
                                    </div>
                                    <div className="td td-potential">
                                      {item.potential_improvement}
                                    </div>
                                    <div className="td td-comment">
                                      <Link
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedComment(item.comment);
                                          setSelectedActivityName(item.activity_name);
                                          setMainIndex(main_index);
                                          setSubIndex(index);
                                          setShowCommentModal(true);
                                        }}
                                      >
                                        Comment
                                      </Link>
                                    </div>
                                    {/* <div className="td td-action">
                                      <div className="activity-badges">
                                        <span className="badge done"> 
                                          {item?.action || 'Approved'}
                                           </span>
                                      </div> */}
                                      {/* {item.action && (
                                        <button className="action-btn">
                                          {item.action}
                                        </button>
                                      )}
                                      {item.status === "Accepted" && (
                                        <button className="status-btn accepted">
                                          Accepted
                                        </button>
                                      )}
                                      {item.status === "Rejected" && (
                                        <button className="status-btn rejected">
                                          Rejected
                                        </button>
                                      )}
                                      {!item.status && !item.action && (
                                        <div className="action-icons">
                                          <button className="icon-btn check">
                                            <Iconography
                                              icon="check"
                                              size={IconographySizes.Small}
                                            />
                                          </button>
                                          <button className="icon-btn cross">
                                            <Iconography
                                              icon="xmark"
                                              size={IconographySizes.Small}
                                            />
                                          </button>
                                        </div>
                                      )} */}
                                    {/* </div> */}
                                  </div>
                                )) : ''}
                            </div>
                          </div>
                        </div>
                      }
                    </div> : ''}
                </>
              ))}
          </div>
        </div>

        {/* Comments & Files Section */}
        <div className="comments-files-section">
          <h2 className="section-title">Add Comments & Files (Optional)</h2>
          <div className="comments-files-grid">
            <div className="comment-wrapper">
              <div className="comment-header">
                <label>Comment (Optional)</label>
                {/* <span className="char-count">
                  {formData.comment.length}/500
                </span> */}
              </div>
              <textarea
                value={formData.comment}
                readOnly={!isEditable}
                onChange={(e) => handleInputChange("comment", e.target.value)}
                placeholder="Comment"
              //maxLength={500}
              />
            </div>

            <div className="files-wrapper">
              {/* <button  className="add-files-btn">ADD FILES</button>
               <input
                id="file-upload"
                type="file"
                multiple
                //onChange={handleFileUpload}
                style={{ display: "none" }}
              /> */}

              <label htmlFor="file-upload" className={`add-files-btn ${!optedIn || !isEditable ? "disabled" : ""}`}>
                ADD FILES
              </label>
              <input
                id="file-upload"
                type="file"
                multiple
                onChange={handleFileUpload}
                style={{ display: "none" }}
                disabled={!isEditable}

              />


              <div className="file-list">

{formData.documents && formData.documents.length ? formData.documents.map((file, index) => (
                  <div key={index} className="file-item">
                    <button
                      type="button"
                      className="document-item"
                      onClick={() => handleViewFile(file)}
                    >
                      <span className="file-name">{file}</span>
                      <Iconography icon="eye" size={IconographySizes.Small} />
                    </button>
                    {isEditable && (
                      <button
                        type="button"
                        className="delete-icon-btn"
                        onClick={() => handleRemoveOldDocument(index)}
                      >
                        <Iconography
                          icon="xmark"
                          size={IconographySizes.Small}
                          className="delete-icon"
                        />
                      </button>
                    )}
                  </div>
                )) : ''}

                {newDocuments && newDocuments.length ? newDocuments.map((file, index) => (
                  <div key={index} className="file-item">
                    <button
                      type="button"
                      className="document-item"
                      onClick={() => handleViewNewDocument(file)}
                    >
                      <span className="file-name">{file.name}</span>
                      <Iconography icon="eye" size={IconographySizes.Small} />
                    </button>
                    {isEditable && (
                      <button
                        type="button"
                        className="delete-icon-btn"
                        onClick={() => handleRemoveDocument(index)}
                      >
                        <Iconography
                          icon="xmark"
                          size={IconographySizes.Small}
                          className="delete-icon"
                        />
                      </button>
                    )}
                  </div>
                )) : ''}
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="submit-section">
          <button className="submit-btn"
            disabled={!isEditable}
            onClick={() => {
              setConfirmationOpen(true);
              setSubmitType('submitted');
            }}
          >
            SUBMIT FOR EVALUATION
          </button>
        </div>
      </div>


      {confirmationOpen &&
        <Modal

          width={420}
          onClose={() => setConfirmationOpen(false)}
          className="delete-confirm-modal"
        >
          <div className="message-button-container">
            {!submitEvaluationConfigurationLoading && !submitted ?
              <>

                <div className="info-container">
                  <Avatar
                    size={AvatarSizes.Large}
                    editorProps={{
                      icon: 'buildings',
                    }}
                  />{" "}
                  {/* <span>{info.name}</span> */}
                </div>

                <div className="message-text">
                  {submitType === 'draft' ?
                    'Are you sure want to save assessment as a draft?'
                    : ' Are you sure want to evaluate the assessment?'}
                </div>


                <div className="button-group">
                  <Button
                    variant="secondary"
                    label="Cancel"
                    onClick={() => setConfirmationOpen(false)}
                  />
                  <div className="delete-button-wrapper">
                    <Button
                      variant="primary"
                      label="Yes"
                      //disabled={deleteButtonLoading}
                      onClick={() => {

                        submitEvaluationFn(submitType)

                      }}
                    />

                  </div>
                </div>
              </> :
              <div className="status-message-modal-container">
                {submitEvaluationConfigurationLoading ? (
                  <Loader variant={LoaderSizes.large} />
                ) : evaluationSuccess ? (
                  <>
                    <Iconography
                      icon="circleCheck"
                      size={IconographySizes.XLarge}
                      theme={IconographyThemes.Success}
                    />
                    <div className="message">
                      {evaluationMessage}
                    </div>
                    <Button
                      variant="primary"
                      label="OK"
                      onClick={() => {
                        setSubmitted(false)
                        setConfirmationOpen(false)
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Iconography
                      icon="circleXmark"
                      size={IconographySizes.XLarge}
                      theme={IconographyThemes.Error}
                    />
                    <div className="message">{evaluationMessage}</div>
                    <Button
                      variant="primary"
                      label="Ok"
                      onClick={() => {
                        setSubmitted(false)
                        setConfirmationOpen(false)
                      }}
                    />
                  </>
                )}
              </div>
            }

          </div>
        </Modal>
      }
    </div>
    {showCommentModal && (
      <CommentModal
        open={showCommentModal}
        onClose={() => setShowCommentModal(false)}
        activityName={selectedActivityName}
        comments={selectedComment}
        onAddComment={(comment) => {
          //console.log("Add comment", comment);
        }}
        onEditComment={(id) => {
          //console.log("Edit comment with id", id);
        }}
        onDeleteComment={(id) => {
          //console.log("Delete comment with id", id);
        }}
        onUpdate={(data:any) => {
          setCommentEngagementWise(data)
          //console.log("Update clicked");
        }}
      />
    )}
    <ActivityDescriptionModal
      open={showDescriptionModal}
      onClose={() => setShowDescriptionModal(false)}
      activityName={selectedActivityName}
      description={selectedDescription}
    />
    </>
  );
};

export default Calculator;
